<template>
  <div class="homePage">
    <div class="big_her">
      <div class="herder">
        <div class="her_l" @click="loginOut">
          <p>注销</p>
          <img src="../../assets/img/zuxiao_icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="big_content">
      <div class="content">
        <h4>在线论文投稿须知</h4>
        <span/>
        <h3 >{{paper_title}}</h3>
        <p class="p40">各位药师:</p>
        <div class="p1193" v-html="this.paper_Html"></div>

        <button @click="
            $router.push({
              path: '/Home/Paperfm',
              query: { type: $route.params.type }
            })
          ">
          我已阅读并接受此须知，开始投稿
        </button>
      </div>
    </div>

    <div class="login_ftrr">
      <p>Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
        paper_title:'',//活动标题
        paper_Html:'',//会议论文
      }
    },
    components: {},
    methods: {
      //获取论文须知
      async Get_paper(){
        const res = await this.$api.Home.getNameValueList()
        this.paper_Html = res.data.site_paper;
        this.paper_title = res.data.site_title;

        console.log(paper_Html);
      },

      loginOut() {
        this.$router.push('/login')
        window.localStorage.clear()
      },
      submitForm(formName) {}
    },

    created() {
      console.log(this.$route.params)
    },

    mounted() {
      this.Get_paper();
      console.log(window.title);
      document.title = "论文及科普作品投稿系统";
    }

  }
</script>
<style lang="less" scoped>
  .homePage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .login_ftrr {
      margin-top: 20px;
      padding-left: 360px;
      height: 39px;
      line-height: 2;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #aaaaaa;
    }

    .pt20 {
      padding-top: 20px;
    }

    .pt7 {
      padding-top: 7px;
    }

    .pt30 {
      padding-top: 30px;
    }

    .p1193 {
      width: 1193px;
      line-height: 2;
      padding-top: 30px;
    }

    .big_content {
      background-color: #f6fbff;
      padding-top: 92px;
      padding-bottom: 82px;
      box-sizing: border-box;
    }

    .content {
      margin: 0 auto;
      width: 1200px;

      // height: 1182px;
      button {
        // margin: 0 auto;
        margin: 64px auto 0;
        width: 350px;
        height: 50px;
        background-color: #00599e;
        border-radius: 5px;
        border: 0;
        display: block;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
      }

      .p40 {
        margin-top: 40px;
      }

      h3 {
        text-align: center;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 36px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0px;
        letter-spacing: 0px;
        color: #00599e;
      }

      h4 {
        text-align: center;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 29px;
      }

      span {
        display: block;
        width: 1200px;
        height: 2px;
        background-color: #c7ddeb;
        margin-bottom: 58px;
      }
    }

    .big_her {
      background: #fff;
      width: 100%;
    }

    .herder {
      height: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 360px;

      .her_l {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 50px;
        background-color: #00599e;
        border-radius: 5px;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
        font-size: 20px;
        line-height: 50px;
        cursor: pointer;

        p {
          margin-right: 13px;
        }
      }
    }
  }
</style>
